<template>
  <div :id="widget.object.wid" class="widget-item" :style="style">
    <div :style="{ height: '100%', width: '100%' }">
      <VisualizeViewer :data="widget.object" />
    </div>
  </div>
</template>

<script>
  import VisualizeViewer from '@/components/apps/visualize/VisualizeViewer.vue';

  import { simpleTypeMixin } from '@/helpers';
  import templateWidget from '@/components/widgets/templates/mixins/templateWidget';

  export default {
    name: 'VisualizeWidget',

    components: {
      VisualizeViewer,
    },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
      },
    },

    data() {
      return {
        showVisualize: true,
      };
    },

    computed: {
      style() {
        return Object.assign({}, this.defaultStyling(this.widget), {
          overflow: 'hidden',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }
</style>
